import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["as", "children"];
import styled from 'foundations-theming/utils';
import { forwardRef } from 'react';
import { filterProps } from '../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../hooks/useMapTokenPropsToCSS';
import { VIEW_RESET_STYLES } from './View.styles';
import { deepMerge } from '../../transitional/utils/deepMerge/deepMerge';
import { jsx as _jsx } from "react/jsx-runtime";
export const StyledView = styled.div.withConfig({
  displayName: "View__StyledView",
  componentId: "vlbzz3-0"
})(({
  $cssStyles,
  $styleOverrides
}) => {
  return deepMerge(Object.assign({}, VIEW_RESET_STYLES, $cssStyles), $styleOverrides !== null && $styleOverrides !== void 0 ? $styleOverrides : {});
});

/**
 * `View` is a primitive layout component that provides access to the
 * style props defined in the design system alongside many of our
 * token values.
 *
 * `View` does not handle flex or grid layouts. Use the `Flex` and `Grid`
 * components for those.
 */
export const View = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      as = 'div',
      children
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps,
    callbackProps
  } = filterProps(restProps);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledView, Object.assign({}, domProps, callbackProps, {
    as: as,
    ref: ref // Styled Components expects a `div` ref even though we pass the `as` prop
    ,
    $cssStyles: cssStyles,
    children: children
  }));
});
View.displayName = 'View';